import getUrl from "Libs/getUrl";
import logger from "Libs/logger";

import { organizationByNameOrIdSelector } from "../organization.selectors";
import { createAppAsyncThunk } from "Store/createAppAsyncThunk";
import { Organization } from "@packages/client";

export type UpdateOrganizationProps = {
  organization: Partial<Organization>;
  organizationDescriptionId: string;
};

export const updateOrganization = createAppAsyncThunk(
  "app/organizations/update_organization",
  async (
    { organizationDescriptionId, organization }: UpdateOrganizationProps,
    { rejectWithValue, getState }
  ) => {
    try {
      const organizationToUpdate = organizationByNameOrIdSelector(getState(), {
        organizationNameOrId: organizationDescriptionId
      });

      if (!organizationToUpdate) {
        return rejectWithValue({
          error: `Organization ${organizationDescriptionId} not found`
        });
      }
      const newOrganization = await organizationToUpdate.update(
        organization,
        organizationToUpdate.getLink("self")
      );

      if (!newOrganization)
        return rejectWithValue({ error: "organization.updateorganization" });

      const updatedOrganization = organizationToUpdate.updateLocal(
        newOrganization.data
      );

      if (organization?.name) {
        // Redirect to the new organization name
        const newPath = getUrl({
          key: "organization.settings",
          props: { organizationId: organization.name }
        });

        return { organization: updatedOrganization, redirectTo: newPath };
      }

      return { organization: updatedOrganization };
    } catch (err) {
      logger(err, {
        action: "updateOrganization",
        organizationDescriptionId,
        organization
      });

      return rejectWithValue({ error: err as string });
    }
  }
);
